












































































































































































































































// TODO: Enable lint.
/* eslint-disable */
import { computed, defineComponent, reactive, SetupContext } from '@vue/composition-api';

import API from '@aws-amplify/api';
import Auth from '@aws-amplify/auth';

import NavHeader from '@/components/NavHeader.vue';
import Footer from '@/components/Footer.vue';

export default defineComponent({
  name: "CPTemplateWizard",
  components: {
    NavHeader,
    Footer
  },
  head: {
    link: [
      { rel: "stylesheet", type: "text/css", href: "/css/style.css" },
      { rel: "stylesheet", type: "text/css", href: "/css/login/template.css" }
    ],
    script: [
      { src: "https://ajax.googleapis.com/ajax/libs/jquery/1.7/jquery.min.js" },
      { src: "/js/toggle_contents.js" }
    ]
  },
  filters: {
    concat: function(elms: string[]) {
      return elms.join('、');
    }
  },

  setup(_, context: SetupContext) {
    const state = reactive({
      step: 1,
      direction: 'vertical',
      template: {
        name: '',
        is_vertical: true, 
        has_description: true,
        has_image: false,
        has_spec: false
      }
    });

    const directionLabel = computed(() => {
      if (state.direction === 'vertical') {
        return '縦型';
      } else {
        return '横型';
      }
    });

    const conceptElements = computed(() => {
      const result = [];

      if (state.template.has_description)
        result.push('商品説明文');

      if (state.template.has_image)
        result.push('画像')

      if (state.template.has_spec)
        result.push('商品のスペック')

      return result;
    });

    const step1ActiveClass = computed(() => {
        return state.step == 1 ? 'active' : 'next';
    });
    const step2ActiveClass = computed(() => {
        return state.step == 2 ? 'active' : 'next';
    });
    const step3ActiveClass = computed(() => {
        return state.step == 3 ? 'active' : 'next';
    });

    function moveToStep1() {
      state.step = 1;
      document!.getElementById('app')!.scrollIntoView();
    };
    function moveToStep2() {
      console.log(state);
      state.step = 2;
      document!.getElementById('app')!.scrollIntoView();
    };
    function moveToStep3() {
      state.step = 3;
      document!.getElementById('app')!.scrollIntoView();
    };

    async function register() {
      console.log(state);
      state.template.is_vertical = (state.direction === 'vertical');

      const options = {
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`
        },
        body: state.template
      }

      API.post('dev', '/cptemplates', options).then(response => {
        console.log(response);
        context.root.$router.push('/template');
      }).catch(err => {
        console.log(err);
      });
    };

    return {
      state,
      directionLabel,
      conceptElements,
      moveToStep1,
      moveToStep2,
      moveToStep3,
      step1ActiveClass,
      step2ActiveClass,
      step3ActiveClass,
      register
    };
  }
});
